import { useEffect, useState } from 'react';
import { WatchlistApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { handleAdminError } from '../../common/SharedFunctions';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { formatDateMonthDayYear } from '@apply/ui';
import LoadPanel from 'devextreme-react/load-panel';

const MaturityHistoryTable = ({ loanId }) => {
    const [data, set_data] = useState([]);
    const [loadingMessage, set_loadingMessage] = useState('');
    const watchlistApi = new WatchlistApi.WatchlistApi(applicationInsights);

    const formatDate = (dt) => {
        if (!dt) {
            return null;
        }
        return formatDateMonthDayYear(dt);
    };

    const onDateRender = (e) => {
        return formatDate(e.value);
    };

    const loadHistoryAsync = async (loanId) => {
        try {
            set_loadingMessage('Retrieving history...');
            const response = await watchlistApi.getMaturityHistory(loanId);
            if (response.statusCode !== 200) {
                throw new Error('Failed to retrieve data!');
            }
            const records = response.result;
            set_data(records);
        } catch (ex) {
            handleAdminError(ex, 'Failed to retrieve records! Please refresh the page and try again.');
        } finally {
            set_loadingMessage('');
        }
    };

    useEffect(() => {
        if (!loanId) {
            return;
        }

        loadHistoryAsync(loanId);
    }, [loanId]);

    if (!loanId) {
        return null;
    }

    return (
        <>
            <DataGrid
                keyExpr={'id'}
                dataSource={data}
                rowAlternationEnabled={true}
                showBorders={true}
                showColumnHeaders={true}
                showRowLines={true}
                wordWrapEnabled={true}
                noDataText={'No maturity history found for this loan'}
            >
                <Column
                    dataField='period'
                    caption='Period'
                    sortIndex={0}
                    sortOrder={'desc'}
                />
                <Column
                    dataField='fromDate'
                    caption='From'
                    width={100}
                    cellRender={onDateRender}
                />
                <Column
                    dataField='toDate'
                    caption='To'
                    width={100}
                    cellRender={onDateRender}
                />
                <Column
                    dataField='months'
                    caption='Months'
                    width={60}
                    alignment='left'
                />
            </DataGrid>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={!!loadingMessage}
                message={loadingMessage}
            />
        </>
    );
};

export default MaturityHistoryTable;
